import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_default_bank_stmt_import_file_hdr_RowClass } from '../../../dbschema';

export class BankStatementImportFileHdrContainerModel extends BaseContainerModel {
    bl_fi_default_bank_stmt_import_file_hdr: bl_fi_default_bank_stmt_import_file_hdr_RowClass = new bl_fi_default_bank_stmt_import_file_hdr_RowClass();
}